export default __webpack_public_path__ + "static/media/angel-down.ec3a6721.svg";